import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { size as _size } from 'lodash';

import FloatingLayer from '../builder/FloatingLayer';
import ButtonCollection from '../builder/ButtonCollection';
import SaveButton from '../builder/SaveButton';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';
import TimeCounterSimple from '../builder/TimeCounterSimple';

const TestInvite = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion ?? false;
	const token = props?.token ?? false;

	if(promotion === false || token === false) return null;

	const activateLink = (cb) => {
		$.post(`/promotions/test_invite/${promotion.id}/${token}`, { action:'activate' }, (r) => {
			if(r.status) {
				if(cb != undefined) cb();
				window.location.href = `/p/${promotion.id}?utm_source=test`;
			} else {
				alert(`Error: ${r.reason}`);
			}
		}, 'JSON');
	};

	const duration = EPDateDiff(EPDateAdd(props.created, 'days', 1), null, 'seconds')

	if(props?.expired ?? false) {
		return (
			<FloatingLayer _class={{size:'small'}} enable_close={false}>
				<div class="without_actions">
					<SectionTitle>Test mode</SectionTitle>

					<SectionSubtitle>This invitation is invalid because it's been used on another device or it has expired. Contact the administrator of the promotion to receive another invitation to test.</SectionSubtitle>
				</div>
			</FloatingLayer>
		)
	}

	return (
		<FloatingLayer _class={{size:'small'}} enable_close={false}>
			<div>
				<SectionTitle>Test mode</SectionTitle>

				<SectionSubtitle>You have received a link to test a promotion.</SectionSubtitle>

				<dl class="invitation_promo_details gui_not_in_bottom">
					<div>
						<dt>{i18n("Promotion ID")}</dt>
						<dd>{promotion.id}</dd>
					</div>

					{(isNotEmpty(promotion, 'organizer')) && (
						<div>
							<dt>{i18n("Organizing brand")}</dt>
							<dd>{promotion.organizer}</dd>
						</div>
					)}

					{(isNotEmpty(promotion, 'title')) && (
						<div>
							<dt>{i18n("Promotion Title")}</dt>
							<dd>{promotion.title}</dd>
						</div>
					)}
				</dl>

				<SectionSubtitle>When you click on it, you'll have 2 hours to test the promotion on this device only. After that, the link will no longer be valid. If you want to test on another device, you need to contact the administrator of the promotion.</SectionSubtitle>

				<div class="gui_flexbox_auto gui_not_in_top">
					<p class="gui_not_in_end_small">{i18n("This link will expire in")}:</p>

					<TimeCounterSimple
						seconds={duration}
						hide_days={true}
					/>
				</div>

				<ButtonCollection in_floating={true}>
					<SaveButton
						onClick={(e, cb) => activateLink(cb)}
					>Confirm and start testing</SaveButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
};

export default injectIntl(TestInvite);